import { get } from 'lodash-es';

export default {
  webhooks: (state) => get(state, 'webhooks', []),
};
